/* @ngInject */
const myRailwayCreateForm = (
  toaster,
  $$railway
) => {
  return {
    restrict: 'E',
    scope: {
      myRailway: '=',
      enableTitle: '=?',
    },
    template: require('./myRailwayCreateForm.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {
      $scope.saveRailway = async (_railway) => {
        try {
          const railway = $$railway.format.server(_railway)
          const response = await $$railway.request.save(railway)
          toaster.message(response.message)
          $scope.reinit()
        } catch (error) {
          toaster.error(error)
        }
      }

      $scope.reinit = () => {
        $scope.myRailway = $$railway.new()
        $scope.createRailwayForm.$setPristine()
        $scope.createRailwayForm.$setUntouched()
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myRailwayCreateForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/directives/forms/myRailwayCreateForm.js